import { DetectionType } from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ResolveSection, { ResolveSectionSelection } from './ResolveSection';

type SectionSelections = Record<DetectionType, ResolveSectionSelection>;

interface Props {
  onClose: () => void;
  selections: SectionSelections;
  activeSection: DetectionType | null;
  activeSectionWithSelection: DetectionType | undefined;
  isLoading: boolean;
  onConfirm: (detectionType: DetectionType, value: string) => void;
  onSelectionChange: (
    sectionType: DetectionType
  ) => (newSelection: ResolveSectionSelection) => void;
  personOptions: string[];
  vehicleOptions: string[];
  incorrectOptions: string[];
}

export function ResolveSections(props: Props) {
  const {
    onClose,
    selections,
    activeSection,
    activeSectionWithSelection,
    isLoading,
    onConfirm,
    onSelectionChange,
    personOptions,
    vehicleOptions,
    incorrectOptions,
  } = props;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-onlight-text-1 dark:text-ondark-text-1 text-base font-semibold">
          Resolve the alarm
        </h2>
        <Button variant="icon" onClick={onClose} title="Close">
          <XMarkIcon className="h-5 w-5" />
        </Button>
      </div>

      <div className="divide-onlight-line-3 dark:divide-ondark-line-3 space-y-4 divide-y">
        <ResolveSection
          title="Person"
          options={personOptions}
          onConfirm={(value) => onConfirm(DetectionType.PERSON, value)}
          isLoading={isLoading && activeSection === DetectionType.PERSON}
          disabled={isLoading && activeSection !== DetectionType.PERSON}
          selection={selections[DetectionType.PERSON]}
          onSelectionChange={onSelectionChange(DetectionType.PERSON)}
          isConfirmDisabled={
            activeSectionWithSelection !== undefined &&
            activeSectionWithSelection !== DetectionType.PERSON
          }
        />
        <div className="pt-4">
          <ResolveSection
            title="Vehicle"
            options={vehicleOptions}
            onConfirm={(value) => onConfirm(DetectionType.VEHICLE, value)}
            isLoading={isLoading && activeSection === DetectionType.VEHICLE}
            disabled={isLoading && activeSection !== DetectionType.VEHICLE}
            selection={selections[DetectionType.VEHICLE]}
            onSelectionChange={onSelectionChange(DetectionType.VEHICLE)}
            isConfirmDisabled={
              activeSectionWithSelection !== undefined &&
              activeSectionWithSelection !== DetectionType.VEHICLE
            }
          />
        </div>
        <div className="pt-4">
          <ResolveSection
            title="Incorrect Detection"
            options={incorrectOptions}
            onConfirm={(value) =>
              onConfirm(DetectionType.INCORRECT_DETECTION, value)
            }
            isLoading={
              isLoading && activeSection === DetectionType.INCORRECT_DETECTION
            }
            disabled={
              isLoading && activeSection !== DetectionType.INCORRECT_DETECTION
            }
            selection={selections[DetectionType.INCORRECT_DETECTION]}
            onSelectionChange={onSelectionChange(
              DetectionType.INCORRECT_DETECTION
            )}
            isConfirmDisabled={
              activeSectionWithSelection !== undefined &&
              activeSectionWithSelection !== DetectionType.INCORRECT_DETECTION
            }
          />
        </div>
      </div>
    </div>
  );
}

export default ResolveSections;
